import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-private-layout',
  template: `<app-sidenav [hideSidenav]="hideSidenav">
    <app-sidenav-header sidenavHeader></app-sidenav-header>
    <app-nav-list sidenavList></app-nav-list>
    <router-outlet mainContent></router-outlet>
  </app-sidenav>`,
})
export class PrivateLayoutComponent implements OnInit, OnDestroy {
  hideSidenav = false;
  private destroy$ = new Subject<void>();

  constructor(private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit(): void {
    this.updateSidenavVisibility();

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe(() => this.updateSidenavVisibility());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateSidenavVisibility(): void {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.hideSidenav = route.snapshot.data?.hideSidenav === true;
  }
}
